/**
 * Shared launch context for Battery Contract and financing-status drawers.
 * Callers pass `returnTo` so Close restores Setup or the proposal page.
 */
export type BatteryDrawerLaunchState = {
  returnTo?: string
}

/**
 * Only in-app Battery proposal paths are accepted. Location state is
 * attacker-influencable via crafted links, so reject absolute URLs,
 * protocol-relative hosts, and escapes.
 */
const isSafeBatteryReturnTo = (path: string): boolean => {
  if (!path.startsWith(`/battery-proposal/`)) {
    return false
  }
  if (path.includes(`://`) || path.includes(`\\`) || path.includes(`..`)) {
    return false
  }
  // Reject `/battery-proposal//evil` and protocol-relative after the prefix.
  if (path.includes(`//`)) {
    return false
  }
  return true
}

export const batteryDrawerReturnTo = (
  state: unknown,
  fallback: string,
): string => {
  if (state != null && typeof state === `object` && `returnTo` in state) {
    const { returnTo } = state as BatteryDrawerLaunchState
    if (typeof returnTo === `string` && isSafeBatteryReturnTo(returnTo)) {
      return returnTo
    }
  }
  return fallback
}
